// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-wrapper {
    /* height: 764px; */
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-top: 30px;
}

.testimonial-header {
    text-align: left;
    color: #000;
    font-size: 34px;
    font-weight: 300;
}

.testimonial-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-evenly;
}

.testimonial-content {
    display: flex;
    padding: 30px;
    text-align: center;
    /* background-color: #fff;
    padding: 22px;
    float: left;
    display: flex;
    flex-direction: row;
    align-items: center; */
}

.testimonial-image-container {
    object-fit: cover;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    margin: 0 auto;
}

/* .testimonial-text-container {
     display: flex;
    flex-direction: column;
    justify-content: center;
} */
.testimonial-content h3 {
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
    white-space: nowrap;
}
.testimonial-content h4 {
    font-size: 17px;
    font-weight: 500;
    white-space: nowrap;
}
.testimonial-content-left {
    padding-right: 20px;
}
.testimonial-text {
    /* font-size: 25px;
    color: #333;
    text-align: left;
    padding-top: 40px; */
    /* height: 250px; */
    /* display: flex;
    align-items: center; */
    display: block;
    display: -webkit-box;
    max-width: 100%;
    /* height: 43px; */
    margin: 0 auto;
    font-size: 20px;
    /* line-height: 1; */
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.swiper-container {
    width: 85%;
    height: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
}

/* .swiper-wrapper {
    display: flex;
    align-items: center;
} */

@media (max-width: 1400px) {
    .swiper-container {
        width: 100%;
        height: 100%;
    }
}

@media (max-width: 700px) {
    .testimonial-content {
        flex-direction: column;
    }
    .testimonial-content .logo-img {
        margin: 0 auto;
    }
}
@media (max-width: 575.98px) { 
    .testimonial-content {
        padding: 15px;
    }
    .testimonial-text-container {
        margin-top: 15px;
    }
    .testimonial-text {
        font-size: 18px;
    }
    .testimonial-header {
        font-size: 30px;
    }
    .testimonial-wrapper {
        margin-top: 20px;
    }
    .testimonial-content .logo-img {
        margin: 0 auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/testimonials.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB;;;;;0BAKsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;;;GAIG;AACH;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI;;;wBAGoB;IACpB,mBAAmB;IACnB;0BACsB;IACtB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB,iCAAiC;IAIjC,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".testimonial-wrapper {\n    /* height: 764px; */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    margin-top: 30px;\n}\n\n.testimonial-header {\n    text-align: left;\n    color: #000;\n    font-size: 34px;\n    font-weight: 300;\n}\n\n.testimonial-container {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: space-evenly;\n}\n\n.testimonial-content {\n    display: flex;\n    padding: 30px;\n    text-align: center;\n    /* background-color: #fff;\n    padding: 22px;\n    float: left;\n    display: flex;\n    flex-direction: row;\n    align-items: center; */\n}\n\n.testimonial-image-container {\n    object-fit: cover;\n    height: 50px;\n    width: 50px;\n    border-radius: 50%;\n    margin: 0 auto;\n}\n\n/* .testimonial-text-container {\n     display: flex;\n    flex-direction: column;\n    justify-content: center;\n} */\n.testimonial-content h3 {\n    font-size: 18px;\n    font-weight: 500;\n    margin-top: 20px;\n    white-space: nowrap;\n}\n.testimonial-content h4 {\n    font-size: 17px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n.testimonial-content-left {\n    padding-right: 20px;\n}\n.testimonial-text {\n    /* font-size: 25px;\n    color: #333;\n    text-align: left;\n    padding-top: 40px; */\n    /* height: 250px; */\n    /* display: flex;\n    align-items: center; */\n    display: block;\n    display: -webkit-box;\n    max-width: 100%;\n    /* height: 43px; */\n    margin: 0 auto;\n    font-size: 20px;\n    /* line-height: 1; */\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.swiper-container {\n    width: 85%;\n    height: 100%;\n}\n\n.swiper-slide {\n    text-align: center;\n    font-size: 18px;\n    background: #fff;\n\n    /* Center slide text vertically */\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-align-items: center;\n    align-items: center;\n}\n\n/* .swiper-wrapper {\n    display: flex;\n    align-items: center;\n} */\n\n@media (max-width: 1400px) {\n    .swiper-container {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media (max-width: 700px) {\n    .testimonial-content {\n        flex-direction: column;\n    }\n    .testimonial-content .logo-img {\n        margin: 0 auto;\n    }\n}\n@media (max-width: 575.98px) { \n    .testimonial-content {\n        padding: 15px;\n    }\n    .testimonial-text-container {\n        margin-top: 15px;\n    }\n    .testimonial-text {\n        font-size: 18px;\n    }\n    .testimonial-header {\n        font-size: 30px;\n    }\n    .testimonial-wrapper {\n        margin-top: 20px;\n    }\n    .testimonial-content .logo-img {\n        margin: 0 auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
